/*=========================================================================================
  File Name: moduleAnnualPlanActions.js
  Description: AnnualPlan Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
 getAllMailChampTemplate({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/getAllMailChampTemplate")
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/AnnualPlan/AddAnnualPlan", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  CopyAnnualPlanFormYear({ commit }, item)
  {
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/CopyAnnualPlanFormYear?fromYear="+item.fromYear.getFullYear()+"&toYear="+item.toYear.getFullYear())
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAnnualPlanBadgetByAnnualPlanID( context,itemid) {

    return new Promise((resolve, reject) => {
      axios.get("API/AnnualPlan/GetAnnualPlanBadgetByAnnualPlanID?ID="+itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseClassByInstructor({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClass/GetCourseClassByInstructor")
        .then((response) => {
          commit('SET_AnnualPlans', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItems({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/GetAll")
        .then((response) => {
          commit('SET_AnnualPlans', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItemsAll({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/GetALLAnnualPlans")
        .then((response) => {
          commit('SET_AnnualPlans', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetALLAnnualPlansAboveDateNow({ commit },search) {
    debugger;
    return new Promise((resolve, reject) => {
      axios.post("api/AnnualPlan/GetALLAnnualPlansAboveDateNow",search)
        .then((response) => {
          commit('SET_AnnualPlans', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SearchAnnualPlan({ commit },search) {

    return new Promise((resolve, reject) => {
      axios.post("api/AnnualPlan/SearchAnnualPlan",search)
        .then((response) => {
          commit('SET_AnnualPlanList', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetClassNoCode(){
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/GetCodeOfClassNo")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetAnnualPlanInPeriod({ commit },period) {
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/GetAnnualPlanInPeriod?startDate="+period.start+"&endDate="+period.end)
        .then((response) => {
          commit('SET_AnnualPlans', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetInstructorSchedule({ commit },period) {
    return new Promise((resolve, reject) => {
      axios.post("api/instructor/GetInstructorSchedule",period)
        .then((response) => {
          commit('SET_InstructorSchedule', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetAnnualPlanInPeriodForInstructor({ commit },period) {
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/GetAnnualPlanInPeriodForInstructor?startDate="+period.start+"&endDate="+period.end)
        .then((response) => {
          commit('SET_InstructorSchedule', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  TraineeSearchAnnualPlan({ commit },search) {
    return new Promise((resolve, reject) => {

//TraineeSearchGroupedAnnualPlanDashBoard
      axios.post("api/AnnualPlan/TraineeSearchGroupedAnnualPlan",search)
        .then((response) => {
          debugger
          commit('SET_AnnualPlans', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  confirmEventInPeriod(context,period) {
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/confirmEventInPeriod?startDate="+period.dateFrom+"&endDate="+period.dateTo)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    commit('UPDATE_AnnualPlan', item)
    return new Promise((resolve, reject) => {
      axios.put("api/AnnualPlan/UpdateAnnualPlan?ID="+item.ID, item)
        .then((response) => {

         // commit('UPDATE_AnnualPlan', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  ConfirmEvent({ commit }, item) {
    commit('UPDATE_AnnualPlan', item)
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/ConfirmAnnualPlan?annualPlanID="+item.ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID(context, itemid) {
    debugger
    var v = parseInt(itemid);
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/GetAnnualPlan?ID="+v )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAnnualByIDForCosting(context, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/GetAnnualByIDForCosting?ID="+ itemid)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAnnualPlanByIDWithTrainee(context, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/GetAnnualPlanByIDWithTrainee?ID="+ itemid)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SetBudgetOfAnnualPlan(context, annualPlan) {
    return new Promise((resolve, reject) => {
      axios.post("api/AnnualPlan/SetBudgetOfAnnualPlan", annualPlan)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/AnnualPlan/DeleteAnnualPlan?ID="+item)
        .then((response) => {
          commit('REMOVE_ITEM', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeAnnualPlanInstructor(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/AnnualPlan/DeleteAnnualPlanInstructor?ID="+item.ID)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  InstructorConfirmation(context,ID)
  {

    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/InstructorConfirmation?annualPlanID="+ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  InstructorReject(context,ID)
  {
    debugger
    return new Promise((resolve, reject) => {
      axios.get("api/AnnualPlan/InstructorReject?annualPlanID="+ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
